import { AppError } from "./AppError";

export class DomainError extends AppError {
  readonly isOperational = true;

  constructor(
    message: string,
    readonly code: string,
  ) {
    super(message);
  }
}
